import { render, staticRenderFns } from "./DadosTerceiroForm.vue?vue&type=template&id=71c6cef0&scoped=true"
import script from "./DadosTerceiroForm.vue?vue&type=script&lang=js"
export * from "./DadosTerceiroForm.vue?vue&type=script&lang=js"
import style0 from "./DadosTerceiroForm.vue?vue&type=style&index=0&id=71c6cef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c6cef0",
  null
  
)

export default component.exports